import { Link, useNavigate } from 'react-router-dom'
import { usePerson } from '../../contexts/PersonContext'
import { personRoleLine, isPresenceOnline } from '../../lib/personDisplay'
import { cn } from '../../lib/cn'
import { Avatar } from '../ui/Avatar'
import { SectionLabel } from '../ui/SectionLabel'
import { SidebarAddButton } from './SidebarAddButton'

/** "Your Family" — managed people rows. Hidden entirely for solo accounts. */
export function FamilySection({ onPick }: { onPick?: () => void }) {
  const { isSolo, people, accountHolderId, activePerson, setActivePerson, role } = usePerson()
  const navigate = useNavigate()

  if (isSolo) return null

  const managesCount = Math.max(0, people.length - 1)

  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-center justify-between gap-2 pl-[10px] pr-[6px]">
        <SectionLabel>Your Family</SectionLabel>
        {role === 'parent' && <SidebarAddButton title="Add a person you manage" onClick={() => navigate('/onboard')} />}
      </div>
      {people.map((p) => {
        const holder = p.id === accountHolderId
        const on = activePerson?.id === p.id
        return (
          <button
            key={p.id}
            type="button"
            onClick={() => { onPick?.(); setActivePerson(p.id) }}
            aria-pressed={on}
            aria-label={`View as ${p.firstName}, ${personRoleLine(p, holder, managesCount)}`}
            className={cn(
              'flex w-full items-center gap-[9px] rounded-btn px-[10px] py-2 text-left transition-colors',
              on ? 'bg-paper-deep' : 'bg-transparent hover:bg-paper-deep/50',
            )}
          >
            <Avatar
              initials={(p.firstName[0] || '?').toUpperCase()}
              tintIndex={p.avatarTintIndex}
              showDot
              online={isPresenceOnline(p)}
            />
            <span className="min-w-0 flex-1">
              <span
                className={cn(
                  'block truncate text-[13px] font-medium leading-tight',
                  on ? 'text-ink' : 'text-ink-soft',
                )}
              >
                {p.firstName}
              </span>
              <span className="block truncate text-[10.5px] leading-tight text-ink-fainter">
                {personRoleLine(p, holder, managesCount)}
              </span>
            </span>
          </button>
        )
      })}
      {role === 'parent' && <Link to="/family" className="px-[10px] py-2 text-[12px] text-terra-deep">Manage family profiles</Link>}
    </div>
  )
}
